import React from "react";
import SubHeader4 from '../../../resources/image/subHeader4.png';
import { connect } from "react-redux";
import CancelCompleteContainer from "../../organisms/hotel/cancelCompleteContainer";
import MembershipReservationPopupContainer from "../../organisms/common/membershipReservationPopupContainer";
import MembershipCancelPopup from "../../organisms/common/membershipCancelPopup";
import { HeaderContainer } from "../../organisms/common/headerContainer";
import { SubHeader } from "../../molecules/subHeader";
import CrawlSenyuubiPopupContainer from "../../organisms/common/crawlSenyuubiPopupContainer";
import { DescriptionHomeFlContainer } from '../../organisms/common/descriptionHomeFlContainer';

class CancelCompleteTemplate extends React.Component {
  render() {
    return (
      <div>
        <HeaderContainer
          Label categoryLabel1={"キャンセル完了"} 
          categoryLabel2={"COMPLETE"}
          bookedConfirmLabel={"＞予約内容の確認・変更・キャンセルはこちら"}
          onClickOpenReservationPopupWindow={this.props.onClickOpenReservationPopupWindow}
          onClickOpenSenyuubiWindow={this.props.onClickOpenSenyuubiWindow}
          />
        <CrawlSenyuubiPopupContainer
          state={this.props.state}
          onClickOpenDescriptionHomeFlWindow={this.props.onClickOpenDescriptionHomeFlWindow}
          onClickCloseSenyuubiPopupWindow={this.props.onClickCloseSenyuubiPopupWindow}
        />
        <DescriptionHomeFlContainer
          state={this.props.state}
          onClickCloseDescriptionHomeFlWindow={this.props.onClickCloseDescriptionHomeFlWindow}
        />
        <MembershipReservationPopupContainer
            state={this.props.state}
            onClickClosePopupWindow={this.props.onClickClosePopupWindow}
            onClickOpenCancelPopupWindow={this.props.onClickOpenCancelPopupWindow}
        />
        <MembershipCancelPopup 
          state={this.props.state}
          onClickCloseCancelPopupWindow={this.props.onClickCloseCancelPopupWindow}
        />
        <CancelCompleteContainer/>
      </div>
    );
  }
}

export default CancelCompleteTemplate;